import React from 'react';
import { Layout, Icon, Row, Col } from 'antd';

import {
  NavigationHomeHatier,
} from './Navigation';

const { Footer } = Layout;

export default () => (
  <Footer style={{
    backgroundColor: 'rgb(68, 70, 73)',
    color: 'white',
    fontSize: '12px',
  }}> 
    <Row>
      <div style={{ maxWidth: '80%', margin: 'auto', textAlign: 'center' }}>
        <Col md={12} xs={24}>
          <div>
            <span style={{
              fontSize: '16px',
              fontWeight: 'bold',
              paddingBottom: '16px',
              paddingTop: '16px'
            }}> Itinéraires littéraires </span> <br />
            <span style={{
              fontSize: '14px',
              paddingBottom: '16px',
              paddingTop: '16px'
            }}> Français 1re </span> <br />
            <NavigationHomeHatier />
          </div>
        </Col>
        <Col md={12} xs={24}>
          <div style={ window.innerWidth < 520 ? { maxWidth: '150px', margin: 'auto', paddingTop: '24px' } : { maxWidth: '150px', margin: 'auto'} }>
            <span style={{
                fontSize: '16px',
                fontWeight: 'bold',
                paddingBottom: '16px',
                paddingTop: '16px',
              }}>  eContact </span> <br />
              <div style={window.innerWidth < 520 ? {
                display: 'flex',
                justifyContent: 'space-between',
              } : {
                display: 'flex',
                justifyContent: 'space-between',
                paddingTop: '16px'
              } }>
                contact@evidenceB.com
              </div>
          </div>
        </Col>
      </div>
    </Row>
  </Footer>
);